export default "__VITE_ASSET__ZUEHA82G__"